module.exports = __webpack_public_path__ + "static/media/img-background.a5a74b4f.jpg";